import React, { Component } from 'react';
import {
	Row,
	Col,
	} from 'reactstrap';
import API from '../API';
import Butt from './Butt';
import { Modal, ModalOpen, ModalClose } from '../Modal';
import { AUAContainer } from '../AUA';
import { T } from '../traks';

function UpgradeToPremiumModalInit(gameId, portfolios, remaining_invites, setGameType) {
	ModalOpen("UpgradeToPremium", {gameId, portfolios, remaining_invites, setGameType});
}

class UpgradeToPremiumInnerContent extends Component {
    render() {
        const upgradeAbort = () => {
            ModalClose();
        }

        const executeUpgrade = () => {
            API.post("/a/upgrade_game", {game_id: this.props.gameId}, (response) => {
                if (response === true) {
                    this.props.setGameType("pro");
                }

                ModalClose();
            });
        }

        const portfolios = this.props.portfolios;
        const remainingInvites = this.props.remaining_invites;
        return (
            <div className="ad_trade_bg p-4">
                <div className='text-center'>
                    <T>You’re about to upgrade the game, which will use {portfolios} invites. You currently have {remainingInvites} invites remaining.</T>
                </div>
                <Row className="pt-4">
                    <Col xs="6">
                        <Butt
                            className="ad_trade_buy_btn w-100 px-3 py-2"
                            onClick={executeUpgrade}
                        >
                            <T>Upgrade Now</T>
                        </Butt>
                    </Col>
                    <Col xs="6">
                        <Butt className="ad_trade_sell_btn w-100 px-3 py-2" onClick={upgradeAbort}><T>Cancel</T></Butt>
                    </Col>
                </Row>
            </div>
        )
    }
}

const UpgradeToPremiumInner = (props) => <AUAContainer><UpgradeToPremiumInnerContent {...props}/></AUAContainer>;

class UpgradeToPremium extends Modal {
    allow_close_via_ui() {
		return true;
	}

	mrender() {
		return <UpgradeToPremiumInner {...this.props}/>;
	}

	get_name() {
		return "UpgradeToPremium";
	}

	get_fullscreen_bg_class() {
		return "ad_signuplogin_dark";
	}

	get_bootstrap_modal_class() {
		return "ad_trade_modal";
	}
}

export {
	UpgradeToPremium,
	UpgradeToPremiumModalInit,
};


// WEBPACK FOOTER //
// ./src/c/UpgradeToPremium.js